import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {AssignUsersEntitlementsResultModal} from './assign-users-entitlements.result.modal';
import {
    clearResult,
    selectAssignUsersEntitlementsBulkUuid,
    selectAssignUsersEntitlementsShown,
    selectAssignUsersEntitlementsTask,
} from './assign-users-entitlements.slice';


export const AssignUsersEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectAssignUsersEntitlementsBulkUuid}
        actionTaskSelector={selectAssignUsersEntitlementsTask}
        actionShownSelector={selectAssignUsersEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <AssignUsersEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
